import { RouteConfig } from "vue-router";
import Banks from "./views/banks/Banks";

export default [
  {
    path: "/dashboard/banks",
    component: Banks,
    meta: { title: "Banks and Payments" },
  },
] as RouteConfig[];
